<template>
  <q-layout view="lHh Lpr lFf">
    <q-header class="bg-white" height-hint="180">
      <header-layout @toggle-drawer="toggleDrawer" />
    </q-header>

    <category-drawer v-model="drawer" />

    <q-footer class="bg-white" bordered>
      <footer-layout />
    </q-footer>

    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script setup lang="ts">
import HeaderLayout from "@/components/HeaderLayout.vue";
import FooterLayout from "@/components/FooterLayout.vue";
import CategoryDrawer from "@/components/CategoryDrawer.vue";
import { useAppStore } from "@/stores/appStore";
import { computed, onMounted } from "vue";
import { useProduct } from "@/composables/useProduct";
import { WholesaleType } from "@/libs/enum";
const appStore = useAppStore();

const drawer = computed({
  get: () => appStore.drawerOpen,
  set: (value: boolean) => appStore.setDrawerOpen(value)
});

const toggleDrawer = () => {
  appStore.setDrawerOpen(!appStore.drawerOpen);
};

const { getListCategoryWholesalePrices } = useProduct();

onMounted(() => {
  getListCategoryWholesalePrices(WholesaleType.CATEGORY);
});
</script>

<style scoped>
:deep(.q-item) {
  border-radius: 4px;
  margin: 2px 8px;
}
</style>
